import React from 'react';
import { Typography } from '@mui/material';
import MLCustomIcon from '../CustomIcon';
import './InfoAlert.module.scss';

const TSInfoAlert = ({
  info1 = '',
  info2,
  footer,
  alertType = '',
  alertIcon = '',
  borderAlignment = 'left',
  iconWidth = '20',
  iconHeight = '20',
}) => {
  return (
    <div
      className={`${alertType} max-h-fit px-6 py-2 ${borderAlignment === 'left' ? 'border-l-[6px] justify-start mr-8' : 'border-r-[6px] justify-end ml-8'} 
                  flex gap-2.5 flex-1 `}
    >
      <MLCustomIcon
        iconName={alertIcon}
        width={iconWidth}
        height={iconHeight}
        className="min-w-5"
      />
      <div className="w-full">
        <div className={`flex items-start flex-col gap-2`}>
          <Typography
            variant="h5"
            paragraph
            fontWeight={700}
            className={`!m-0 ${alertType}`}
          >
            {info1}
          </Typography>
          {info2 && (
            <Typography variant="h5" paragraph className={`!m-0 ${alertType}`}>
              {info2}
            </Typography>
          )}
        </div>
        {footer && (
          <div>
            <Typography
              variant="h6"
              paragraph
              className={`!m-0 [var(--Grey-80)] text-right italic`}
            >
              {footer}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

export default TSInfoAlert;
